import { feedSlice } from './slice';

export const { actions, reducer } = feedSlice;
export * as thunks from './thunks';
export * from './types';
